import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HTTP } from "../api/http-common";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { CustomModal } from '../component/ReusableComponents';
import EventCommonView from './EventCommonView';

function EventList() {
    const access_token = localStorage.getItem('access_token');
    const navigate = useNavigate();

    const [events, setEvents] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const [formData, setFormData] = useState({
        id: "",
        title: "",
        description: "",
        start_date: "",
        // end_date: "",
        start_time: "",
        end_time: "",
        price: "",
        // tag: "",
        image: "",
        address: "",
        city_id: "",
        state: "",
        postal_code: "",
        longitude: "",
        latitude: "",
        event_url: ""
    });

    const formatTime = (time) => {
        const [hours, minutes] = time.split(":");
        return new Date(0, 0, 0, hours, minutes).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
    };

    // Function to generate Google Calendar URL
    const getGoogleCalendarUrl = () => {
        return `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(events.title)}
        &dates=${events.start_date.replace(/-/g, "")}T${events.start_time.replace(/:/g, "")}00Z/
        ${events.start_date.replace(/-/g, "")}T${events.end_time.replace(/:/g, "")}00Z
        &details=${encodeURIComponent(events.description || "No description")}
        &location=${encodeURIComponent(events.address || "No location")}`;
    };

    // Function to generate Outlook Calendar URL
    const getOutlookCalendarUrl = () => {
        return `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(events.title)}
        &startdt=${events.start_date}T${events.start_time}
        &enddt=${events.start_date}T${events.end_time}
        &body=${encodeURIComponent(events.description || "No description")}
        &location=${encodeURIComponent(events.address || "No location")}
        &allday=false&path=/calendar/action/compose`;
    };

    const getICalendarUrl = (event) => {
        const formatDate = (date, time) => {
            return `${date.replace(/-/g, "")}T${time.replace(/:/g, "")}00Z`;
        };

        const icsData = `BEGIN:VCALENDAR
        BEGIN:VEVENT
        SUMMARY:${event.title}
        DTSTART:${formatDate(event.start_date, event.start_time)}
        DTEND:${formatDate(event.start_date, event.end_time)}
        DESCRIPTION:${event.description || "No description"}
        LOCATION:${event.address || "No location"}
        END:VEVENT
        END:VCALENDAR`;

        const blob = new Blob([icsData], { type: "text/calendar" });
        return URL.createObjectURL(blob);
    };


    const [eventId, setEventId] = useState(null);

    const handleEventClick = (clickInfo) => {
        const eventId = clickInfo.event.id;
        const eventData = events.find(event => event.id.toString() === eventId);

        setEventId(eventId);
        if (eventData) {
            setSelectedEvent(eventData);
            setIsModalOpen(true);
        }
    };

    const [isExpanded, setIsExpanded] = useState(false);
    const maxLength = 200;
    const fetchEvents = async () => {
        let config = {
            headers: { "Content-Type": "application/json", token: access_token },
        };

        try {
            const response = await HTTP.post("/user/get_event", {}, config);

            if (response.status === 200) {
                

                setFormData(response.data.upcoming_events.length > 0 ? response.data.upcoming_events : formData);
                setEvents(response.data.all_events);

                setPastEvents(response.data.past_events);
            }
        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }

    useEffect(() => {
        fetchEvents();
    }, []);

    return (
        <div className="container mx-auto p-8">
            <div className="flex justify-end mt-4">
                <button
                    className=" text-white font-semibold py-2 px-4 rounded-lg text-center cursor-pointer transition w-32 theme-button"
                    onClick={() => navigate('/events/create')}
                >
                    Add Event
                </button>
            </div>


            <div className="mt-4 bg-white p-4 border border-gray-300 rounded-lg shadow-md transition-opacity duration-300">
                <FullCalendar
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    events={events.map(event => ({
                        title: event.title,
                        start: event.start_date,
                        id: event.id.toString(),
                    }))}
                    eventClick={handleEventClick}
                    eventContent={(arg) => {
                        return {
                            html: `<div style="cursor: pointer;">${arg.event.title}</div>`,
                        };
                    }}
                />
            </div>

            <CustomModal width='70%' isOpen={isModalOpen} onClose={handleCloseModal}>
                {selectedEvent ? (
                    <>
                    {console.log("selectedEvent", selectedEvent)}
                    
                        <div className="">
                            <button
                                className="theme-button text-white font-semibold py-2 px-4 rounded-lg text-center cursor-pointer transition w-32"
                                onClick={() => navigate(`/events/edit/${eventId}`)}
                            >
                                Edit Event
                            </button>
                        </div>
                        <EventCommonView
                            event={selectedEvent}
                            dropdownOpen={dropdownOpen}
                            setDropdownOpen={setDropdownOpen}
                            getGoogleCalendarUrl={getGoogleCalendarUrl}
                            getOutlookCalendarUrl={getOutlookCalendarUrl}
                            getICalendarUrl={getICalendarUrl}
                            formatTime={formatTime}
                            adminView={true}
                        />
                    </>
                ) : (
                    <p className="text-gray-500">No event selected.</p>
                )}
            </CustomModal>

            <div className="mt-4 bg-white p-4 border border-gray-300 rounded-lg shadow-md hidden">
                <h2 className="text-2xl font-bold mb-4">Past Events</h2>

                {pastEvents.length === 0 ? (
                    <p className="text-gray-500">No Events available.</p>
                ) : (
                    pastEvents.map((event, index) => (
                        <div key={index} className="flex border-b pb-4 mb-4">
                            <div className="text-center text-gray-700 w-16 flex-shrink-0">
                                <p className="text-3xl font-bold">{new Date(event.start_date).getDate()}</p>
                                <p className="text-lg">{new Date(event.start_date).toLocaleString("default", { month: "short" })}</p>
                                <p className="text-sm">{new Date(event.start_date).getFullYear()}</p>
                            </div>

                            <div className="flex-grow pl-4">
                                {/* <p className="text-purple-600 font-bold">{event.tag || "General"}</p> */}
                                <p className="text-gray-600">
                                    {new Date(event.start_date).toLocaleTimeString()}
                                </p>
                                <h3 className="text-xl font-semibold text-black">{event.title}</h3>
                                <p className="text-gray-700 font-medium">{event.address}, {event.state}</p>
                                <p className="text-gray-500">
                                    {isExpanded
                                        ? event.description
                                        : `${event.description.slice(0, maxLength)}...`}

                                    {event.description.length > maxLength && (
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent parent click event
                                                navigate(`/events/${event.id}`); // Redirect to event details page
                                            }}
                                            className="text-blue-500 mt-2 underline"
                                        >
                                            Read More
                                        </button>
                                    )}
                                </p>
                                <p className="text-gray-700 font-semibold">Price: ${event.price || "Free"}</p>
                            </div>

                            {event.image && (
                                <div className="w-32 h-32 flex-shrink-0 ml-4">
                                    <img
                                        src={event.image}
                                        alt={event.title}
                                        className="w-full h-full object-cover rounded-lg"
                                    />
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default EventList;
